import React from 'react';

export const UnauthorizedComponent: React.FC = () => {
  return (
    <h3 className="ml-5 pt-3">
      Looks like you do not have all the access rights. Please check the guides
      on our sharepoint:{' '}
      <a
        href={
          'https://iweof.sharepoint.com/teams/o365g_fmsreporting_itnl012/SitePages/Request-access-instructions.aspx'
        }
      >
        Access guide
      </a>{' '}
      to check and/or request access. Contact your superuser if you need
      support.
    </h3>
  );
};
